import { config } from "../../../../enviroment";
import axios from "axios";

export const quickpayService = {
  postbalance,
};

function postbalance(uniqueId,accountId) {
  let APIinput =
      `query{ postBalanceDetails(input :{
        ` + uniqueId+`:"`+
      accountId +
      `",tenantCode:"` +
      config.parameters.TENANT_CODE +
      `"       
    } ) {  accountId customerName customerClass mobileNumber emailId  accountType balanceRemaining connectionStatus customerType minRecharge}}`;
  
  return new Promise((resolve, reject) => {
    axios
      .post(config.urls.USAGE_SERVICE_BASE_URL, {
        query: APIinput,
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}
